function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCommentsBubblePlain = function SvgCommentsBubblePlain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.334 2.918a8.653 6.974 0 0 0-8.652 6.975 8.653 6.974 0 0 0 1.953 4.412l-1.373 3.648 5.056-1.525h.002a8.653 6.974 0 0 0 3.014.437 8.653 6.974 0 0 0 8.654-6.972 8.653 6.974 0 0 0-8.654-6.975zm.008.937a7.47 6.02 0 0 1 7.47 6.022 7.47 6.02 0 0 1-7.47 6.02 7.47 6.02 0 0 1-3.156-.565 2335.933 2335.933 0 0 0-3.094.938h-.004l-.012.003.004-.01v-.001l.002-.002v-.002c.055-.147.421-1.126.84-2.238a7.47 6.02 0 0 1-2.05-4.143 7.47 6.02 0 0 1 7.47-6.022Z",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#4ea5b5",
      fillOpacity: 1,
      strokeWidth: 2.20137
    }
  }));
};
export default SvgCommentsBubblePlain;